const analyticsLoader = {
    load (appId) {
        const scriptTemplate = `
        <!-- Global site tag (gtag.js) - Google Ads: ${appId} -->
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-${appId}"></script>
        <script>
           window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-${appId}');
        </script>
        `
        return scriptTemplate
    },
}

export default analyticsLoader
